/**
 * Shared API types and constants
 * Used by both apiClient and tokenRefreshManager to avoid circular dependencies
 */

import { TwoFactorMethod } from '@/types/misc';
import { getPublicRuntimeConfig } from '@/utils/publicRuntimeConfig';

// Base API Response wrapper (matches backend structure)
export type ApiResponse<T> = {
  success: boolean;
  data: T | null;
  message?: string;
  error?: string;
  details?: {
    session_id?: string;
    twofa_method?: TwoFactorMethod;
  };
};

export type ApiError = {
  message: string;
  status?: number;
  details?: {
    session_id?: string;
    twofa_method?: TwoFactorMethod;
  };
};

export type ApiResult<T> = {
  data: T | null;
  error: ApiError | null;
};

export const API_BASE_URL = getPublicRuntimeConfig().backendUrl;
